import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';

interface NavigationControlsProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onBack: () => void;
  isComplete: boolean;
}

export function NavigationControls({
  currentStep,
  totalSteps,
  onNext,
  onBack,
  isComplete
}: NavigationControlsProps) {
  return (
    <div className="mt-8 flex justify-between">
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={onBack}
        className={`flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors
          ${currentStep === 0
            ? 'text-gray-400 cursor-not-allowed'
            : 'text-primary-600 hover:text-primary-700'
          }`}
        disabled={currentStep === 0}
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back
      </motion.button>

      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={onNext}
        className={`flex items-center px-6 py-2 text-sm font-medium text-white rounded-lg transition-colors
          ${isComplete
            ? 'bg-green-600 hover:bg-green-700'
            : 'bg-primary-600 hover:bg-primary-700'
          }`}
      >
        {isComplete ? (
          'Complete'
        ) : (
          <>
            Next
            <ArrowRight className="w-4 h-4 ml-2" />
          </>
        )}
      </motion.button>
    </div>
  );
}